import React, {useContext, useState, useEffect} from 'react';
import {injectIntl} from "react-intl";
import SelectField from "@FormElements/SelectField";
import FormContext from "formContext";

function TempSalarySelectField({intl, settings, ...rest}) {
  const {additionalData: {masterLists}, currentStep, setFormData} = useContext(FormContext);
  const {state} = settings || {};
  const {name} = settings.salaryType || {};
  const {onChange} = rest;

  settings.options = [{
    value: '',
    label: intl.formatMessage({id: 'Register.Form.Salary.Field.EmptyOption'})
  }];

  const handleSalaryTypeChange = event => {
    const {value} = event.target;
    setFormData(prev => {
      if (!prev[currentStep]) {
        prev[currentStep] = {};
      }
      const salaryTypeName = settings.salaryType.name;
      prev[currentStep][salaryTypeName] = value;
      return {
        ...prev
      }
    });
    onChange(event);
  }

  const SalaryTypeField = () => {
    return (
      <SelectField
        settings={{...settings, ...settings.salaryType}}
        {...rest}
        onChange={handleSalaryTypeChange}
      />
    )
  };


  const SalaryField = () => {
    let selectedSalaryType;
    if (state && state.hasOwnProperty(name) && state[name] && state[name].length) {
      selectedSalaryType = state[name];
    }

    const salaryOptions = [];

    if (masterLists && masterLists.hasOwnProperty('TempSalaryRange')) {
      const {TempSalaryRange} = masterLists;
      if (TempSalaryRange.length) {
        TempSalaryRange.forEach(salary => {
          if (salary.ParentCode === selectedSalaryType) {
            salaryOptions.push({
              value: salary.Code,
              label: salary.ListValue
            })
          }
        });
      }
    }

    if (!salaryOptions.length) {
      return '';
    }

    settings.options = salaryOptions;

    return (
      <SelectField
        settings={settings}
        {...rest}
      />
    )
  }

  return (
    <>
      <SalaryTypeField />
      <SalaryField />
    </>
  )
}

export default injectIntl(TempSalarySelectField);
